import { useEffect, useState } from 'react'

export function useIsDesktop(breakpoint = 768) {
  const [isDesktop, setIsDesktop] = useState(false)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    if (!isClient) return

    const checkIsDesktop = () => {
      setIsDesktop(window.innerWidth >= breakpoint)
    }

    checkIsDesktop()
    window.addEventListener('resize', checkIsDesktop)

    return () => window.removeEventListener('resize', checkIsDesktop)
  }, [breakpoint, isClient])

  return isDesktop
}
